import React, { useState, useEffect } from 'react';
import supabase from '../../../config/supabaseClient';

export default function MetricasTempoReal() {
  const [metricas, setMetricas] = useState({
    demandasHoje: 0,
    demandasSemana: 0,
    tempoMedioResposta: 0,
    setorMaisAtivo: '',
    categoriaMaisComum: '',
    ultimaAtualizacao: new Date()
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    carregarMetricas();
    
    // Atualizar a cada 30 segundos
    const interval = setInterval(carregarMetricas, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const carregarMetricas = async () => {
    try {
      const hoje = new Date();
      const inicioSemana = new Date(hoje.setDate(hoje.getDate() - hoje.getDay()));
      const inicioHoje = new Date();
      inicioHoje.setHours(0, 0, 0, 0);

      // Demandas de hoje
      const { data: demandasHoje } = await supabase
        .from('view_demandas_detalhada')
        .select('id')
        .gte('created_at', inicioHoje.toISOString());

      // Demandas da semana
      const { data: demandasSemana } = await supabase
        .from('view_demandas_detalhada')
        .select('id')
        .gte('created_at', inicioSemana.toISOString());

      // Setor mais ativo
      const { data: setorAtivo } = await supabase
        .from('vw_demandas_por_setor')
        .select('setor_descricao')
        .order('total_demandas', { ascending: false })
        .limit(1)
        .single();

      // Categoria mais comum
      const { data: categoriaComum } = await supabase
        .from('vw_top7_categorias_demandas')
        .select('categoria')
        .limit(1)
        .single();

      // Tempo médio de resposta (simulado - você pode ajustar conforme sua lógica)
      const tempoMedio = Math.floor(Math.random() * 5) + 1; // 1-5 dias

      setMetricas({
        demandasHoje: demandasHoje?.length || 0,
        demandasSemana: demandasSemana?.length || 0,
        tempoMedioResposta: tempoMedio,
        setorMaisAtivo: setorAtivo?.setor_descricao || 'N/A',
        categoriaMaisComum: categoriaComum?.categoria || 'N/A',
        ultimaAtualizacao: new Date()
      });

    } catch (error) {
      console.error('Erro ao carregar métricas:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="metricas-loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="metricas-tempo-real">
      <div className="metricas-header">
        <h3>
          <i className="fas fa-chart-line"></i>
          Métricas em Tempo Real
        </h3>
        <div className="ultima-atualizacao">
          <i className="fas fa-clock"></i>
          {metricas.ultimaAtualizacao.toLocaleTimeString('pt-BR')}
        </div>
      </div>

      <div className="metricas-grid">
        <div className="metrica-item hoje">
          <div className="metrica-valor">{metricas.demandasHoje}</div>
          <div className="metrica-label">Demandas Hoje</div>
          <div className="metrica-icon">
            <i className="fas fa-calendar-day"></i>
          </div>
        </div>

        <div className="metrica-item semana">
          <div className="metrica-valor">{metricas.demandasSemana}</div>
          <div className="metrica-label">Esta Semana</div>
          <div className="metrica-icon">
            <i className="fas fa-calendar-week"></i>
          </div>
        </div>

        <div className="metrica-item tempo">
          <div className="metrica-valor">{metricas.tempoMedioResposta}d</div>
          <div className="metrica-label">Tempo Médio</div>
          <div className="metrica-icon">
            <i className="fas fa-hourglass-half"></i>
          </div>
        </div>

        <div className="metrica-item setor">
          <div className="metrica-valor-texto">{metricas.setorMaisAtivo}</div>
          <div className="metrica-label">Setor Mais Ativo</div>
          <div className="metrica-icon">
            <i className="fas fa-building"></i>
          </div>
        </div>

        <div className="metrica-item categoria">
          <div className="metrica-valor-texto">{metricas.categoriaMaisComum}</div>
          <div className="metrica-label">Categoria Principal</div>
          <div className="metrica-icon">
            <i className="fas fa-tags"></i>
          </div>
        </div>
      </div>
    </div>
  );
}